import { clubApi } from '@repo/api-client';
import { LoaderFunctionArgs, Outlet, redirect } from 'react-router';
import { urlCourt, urlCourtReservations } from '@/urls';
import { route as routeCourtReservations } from './reservations';

export const route = {
  loader: async ({ params, request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const segments = url.pathname.split('/').filter(Boolean);
    const last = segments.at(-1);
    const isAtCourtRoot = last === String(params.courtId);
    if (isAtCourtRoot) {
      return redirect(urlCourtReservations(params.id as string, params.courtId as string));
    }
    return await clubApi.getCourtById(params.id as string, params.courtId as string);
  },
  element: <Outlet />,
  children: [routeCourtReservations],
  path: urlCourt(':id', ':courtId'),
  handle: {
    title: (data: { name: string }) => `Cancha ${data.name}`,
  },
};
